import MenuBar from "../Component/MenuBar";
import PageBanner from '../Component/PageBanner';
import Sidebar from '../Component/Sidebar';
import Footer from "../Component/Footer";
const Radhashtami = () => {
    return (
        <>
            <MenuBar />
            <Sidebar />

            {/* Page Banner */}
            <PageBanner title="Radhashtami Satsang & Celebrations" />


            <div className="container" style={{ paddingBottom: "40px" }}>

                {/* Heading */}
                <div className="auto-container">
                    <div className="centered">
                        <hr />
                        <h3>Radhashtami Satsang &amp; Celebrations</h3>
                        <h4 className="text-center" style={{ color: "#666", marginTop: "8px" }}>
                            Saturday, September 19th &nbsp;|&nbsp; 6:00 PM – 9:00 PM
                        </h4>
                        <h5 className="text-center" style={{ color: "#888", marginTop: "5px" }}>
                            Yugal Kunj &nbsp;·&nbsp; 2769 Duluth Hwy, Duluth, GA 30096
                        </h5>
                        <p className="text-center" style={{ marginTop: "12px", fontStyle: "italic", color: "#c0392b", fontSize: "16px" }}>
                            Celebrate Radhashtami with satsang, devotional programs, flower poojan, and special leela performances.
                        </p>
                        <hr />
                    </div>
                </div>

                {/* Flyer */}
                <div className="row">
                    <div className="col-lg-12">
                        <div className="card card-margin">
                            <div className="card-header no-border">
                                <h5 className="card-title">Radhashtami 2026 – Event Flyer</h5>
                            </div>
                            <div className="card-body pt-0">
                                <div className="widget-49">
                                    <figure className="image">
                                        <img
                                            src="https://yugalkunj.org/images/Radhashtami.png"
                                            alt="Radhashtami Satsang & Celebrations 2026"
                                            style={{ width: "100%" }}
                                        />
                                        <a
                                            href="https://yugalkunj.org/images/Radhashtami.png"
                                            className="lightbox-image overlay"
                                            data-fancybox="gallery-radhashtami"
                                        ></a>
                                    </figure>
                                    <br />
                                    <div className="widget-49-meeting-action">
                                        <a
                                            href="https://yugalkunj.org/images/Radhashtami.png"
                                            target="_blank"
                                            rel="noreferrer"
                                            className="btn btn-sm btn-flash-border-primary"
                                        >
                                            View Flyer
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Event Highlights */}
                <hr />
                <div className="row">
                    <div className="col-lg-12">
                        <div className="card card-margin">
                            <div className="card-header no-border">
                                <h5 className="card-title">Event Highlights</h5>
                            </div>
                            <div className="card-body pt-0">
                                <div className="inner_heading_title orange-border">
                                    <ul className="satsang_list">
                                        <li><strong>Baby Radha Jhoola</strong></li>
                                        <li><strong>Abhishek</strong></li>
                                        <li><strong>Radha Rani Flower Poojan</strong></li>
                                        <li><strong>Special Leela Performance</strong></li>
                                        <li><strong>Dinner Prasad</strong></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Event Details */}
                <hr />
                <div className="row">
                    <div className="col-lg-12">
                        <div className="card card-margin">
                            <div className="card-header no-border">
                                <h5 className="card-title">Event Details</h5>
                            </div>
                            <div className="card-body pt-0">
                                <div className="inner_heading_title orange-border">
                                    <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '15px' }}>
                                        <tbody>
                                            <tr style={{ borderBottom: '1px solid #eee' }}>
                                                <td style={{ padding: '10px 12px', fontWeight: 'bold', color: '#7d3c98', width: '140px' }}>Event</td>
                                                <td style={{ padding: '10px 12px' }}>Radhashtami Satsang &amp; Celebrations</td>
                                            </tr>
                                            <tr style={{ borderBottom: '1px solid #eee', background: '#fafafa' }}>
                                                <td style={{ padding: '10px 12px', fontWeight: 'bold', color: '#7d3c98' }}>Date</td>
                                                <td style={{ padding: '10px 12px' }}>Saturday, September 19th, 2026</td>
                                            </tr>
                                            <tr style={{ borderBottom: '1px solid #eee' }}>
                                                <td style={{ padding: '10px 12px', fontWeight: 'bold', color: '#7d3c98' }}>Time</td>
                                                <td style={{ padding: '10px 12px' }}>6:00 PM – 9:00 PM</td>
                                            </tr>
                                            <tr style={{ borderBottom: '1px solid #eee', background: '#fafafa' }}>
                                                <td style={{ padding: '10px 12px', fontWeight: 'bold', color: '#7d3c98' }}>Venue</td>
                                                <td style={{ padding: '10px 12px' }}>Yugal Kunj</td>
                                            </tr>
                                            <tr style={{ background: '#fff8e1' }}>
                                                <td style={{ padding: '10px 12px', fontWeight: 'bold', color: '#7d3c98' }}>Address</td>
                                                <td style={{ padding: '10px 12px' }}>2769 Duluth Hwy, Duluth, GA 30096</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Location */}
                <hr />
                <div className="row" style={{ marginBottom: "30px" }}>
                    <div className="col-lg-12">
                        <div className="card card-margin">
                            <div className="card-header no-border">
                                <h5 className="card-title">Location</h5>
                            </div>
                            <div className="card-body pt-0">
                                <div className="inner_heading_title purple-border" style={{ paddingLeft: "20px" }}>
                                    <h4>Yugal Kunj</h4>
                                    <p>2769 Duluth Hwy, Duluth, GA 30096</p>
                                    <p><strong>Date:</strong> Saturday, September 19th, 2026</p>
                                    <p><strong>Time:</strong> 6:00 PM – 9:00 PM</p>
                                    <br />
                                    <a
                                        href="https://maps.google.com/?q=2769+Duluth+Hwy,+Duluth,+GA+30096"
                                        target="_blank"
                                        rel="noreferrer"
                                        className="btn btn-sm btn-flash-border-primary"
                                    >
                                        Open in Google Maps
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

            <Footer />
        </>
    );
};

export default Radhashtami;
